<template>
  <label class="col-form-label" :for="name">{{ label }}</label>
  <select :class="`form-control ${errorMessage ? 'is-invalid' : 'is-valid'}`" :name="name" :id="name"
    @change="onChange($event)" @blur="handleBlur" :value="inputValue" :disabled="disabled">
    <option value="0">--Seleccione--</option>
    <option v-if="isLoading" disabled>Cargando...</option>
    <option :value="item.id" v-for="(item, key) in items" :key="key">
      {{ item.text }}
    </option>
  </select>

  <span :class="`d-inline-block ${errorMessage ? 'invalid-feedback' : 'valid-feedback'
    }`" v-show="errorMessage">
    {{ errorMessage }}
  </span>
</template>

<script>
import { watch, ref, onMounted, toRef } from "vue";
import { useField } from "vee-validate";
import { getData } from "../js/util/fetchhandler";
import { getIn } from "yup";
// import { errorMessage } from "../js/util/notifications";

export default {
  props: {
    modelValue: {
      type: [Number, String],
      default: "0",
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    urlPath: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  // watch: {
  //   urlPath: {
  //     immediate: true,
  //     handler(newUrl) {
  //       if (newUrl) {
  //         console.log(newUrl);
  //         this.getItems();
  //       }
  //     }
  //   }
  // },
  setup(props, { emit }) {
    const items = ref([]);
    const isLoading = ref(false);
    const {
      value: inputValue,
      errorMessage,
      handleBlur,
      handleChange,
      meta,
    } = useField(props.name, 0, {
      syncVModel: true,
      validateOnValueUpdate: true,
      validateOnMount: true
    });

    onMounted(() => {
      // getItems();
    });

    const onChange = (event) => {
      handleChange(event, true);
      emit("update:modelValue", event.target.value);
    };

    const getItems = () => {
      try {
        if(props.urlPath == null || props.urlPath == "" || props.urlPath.includes("undefined") || props.urlPath.includes("null")) return;
        
        isLoading.value = true;
        getData(`${APP.BASEURL}${props.urlPath}`).then(function (data) {
          items.value = data;
        });
      } catch (error) {
        console.error('Error fetching options:', error);
      } finally {
        isLoading.value = false;
      }

    };

    watch(() => props.urlPath, (newUrl) => {
    if (newUrl) {
      getItems();
    }
  }, { immediate: true });

    return {
      onChange,
      handleChange,
      handleBlur,
      errorMessage,
      inputValue,
      meta,
      items,
      getItems,
      isLoading
    };
  }
};
</script>

<style type="text/css"></style>
